// extracted by mini-css-extract-plugin
export default {"component":"styles__component--SL4HK","portals":"styles__portals--UGd1_"};